<template>
  <div>
    <b-modal
      id="historicoInativacaoList"
      ref="historicoInativacaoList"
      button-size="sm"
      no-close-on-backdrop
      no-stacking
      ok-olny
      ok-title="Ok"
      size="lg"
      cancel-title=""
      :cancel-disabled="true"
      cancel-variant="false"
    >
      <div slot="modal-title">
        <h5>{{ 'Histórico de inativação - ' + empresa.razaoSocial }}</h5>
        <fieldset class="font-weight-bold text-muted">
          Histórico de inativação e reativação da empresa
        </fieldset>
      </div>
      <div
        v-if="loading"
        class="text-center my-3"
      >
        <b-spinner label="Carregando..." />
      </div>
      <visualizacao
        v-else
        :empresa="historico"
      />
    </b-modal>
  </div>
</template>

<style lang="scss">
.modal:nth-of-type(even) {
  z-index: 1052 !important;
}
.modal-backdrop.show:nth-of-type(even) {
  z-index: 1051 !important;
}
</style>

<script>
import api from '@/app/empresas/shared/services/api'

export default {
  name: 'HistoricoInativacaoView',
  components: {
    Visualizacao: () => import('./shared/components/visualizacao/Visualizacao.vue'),
  },
  props: {
    empresa: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      historico: [],
      loading: false,
      error: null,
    }
  },
  methods: {
    show() {
      this.$refs.historicoInativacaoList.show()
      this.carregarHistorico()
    },
    carregarHistorico() {
      if (!this.empresa.id) return

      this.loading = true
      this.error = null
      this.historico = [] // Limpa lista anterior ao carregar

      api.getHistoricoInativacao(this.empresa.id)
        .then(response => {
          this.historico = response.data
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.error = 'Erro ao carregar histórico.'
          this.$erro(error)
          this.$erro('Não foi possível carregar o histórico de inativação.')
        })
    },
  },
}
</script>
